var map = {
	"./ar/photo/PhotoPage.vue": [
		8053,
		53
	],
	"./en/photo/PhotoPage.vue": [
		3367,
		367
	],
	"./fa/photo/PhotoPage.vue": [
		5316,
		316
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8042;
module.exports = webpackAsyncContext;